import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import {Button} from 'rmwc/Button';
import TPOUserIndividualResource from './TPOUserIndividualResource';
import TQUserIndividualResource from './TQUserIndividualResource';
import UserInternalResourceComponent from './UserInternalResourceComponent';
import UserExternalResourceComponent from './UserExternalResourceComponent';

class MyBookmarksPage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            userAccess: false,
    		data:{
                tpoResourceDetails: [],
                tqResourceDetails: [],
                mcExtResourceDetails: [],
                mcIntResourceDetails: []
    		},
            errorMsg: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()

        this.props.history.push('/portal/app/user/my_learning_arc_section')
    }

    componentDidMount(){
        let data = Object.assign({}, this.state.data)

        return api.renderUserBookmarkedResources(this.props.user.accessToken)
        .then((result) => {
            if (result.status === 'success') {
                data.tpoResourceDetails = result.data.tpo
                data.tqResourceDetails = result.data.tq
                data.mcExtResourceDetails = result.data.mc_external
                data.mcIntResourceDetails = result.data.mc_internal
                this.setState({data: data, userAccess: true})
            }
            else if (result.status == 'no_access'){
                this.setState({userAccess: false})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while fetching. Please try again after sometime.'})
            }
        })
    }

    render () {
        let tpoResourceComponent
        let tqResourceComponent
        let mcExtResourceComponent
        let mcIntResourceComponent
        let displayComponent
        let handleBackAction = this.handleBackAction

        if(this.state.data.tpoResourceDetails.length>0){
            tpoResourceComponent = (
                <div>
                    {this.state.data.tpoResourceDetails.map(function(resource){
                        return(
                            <TPOUserIndividualResource tpoResourceId = {resource.id}
                                tpoResourceName = {resource.name}
                                tpoResourceLink = {resource.resource_link}
                                tpoResourceAuthor = {resource.author}
                                tpoResourceDescription = {resource.description} />
                        )
                    })}
                </div>
            )
        }
        else{
            <div>
                <Typography use="subtitle2"> You have not Bookmarked any TPO Resource.</Typography>
            </div>
        }
        if(this.state.data.tqResourceDetails.length>0){
            tqResourceComponent = (
                <div>
                    {this.state.data.tqResourceDetails.map(function(resource){
                        return(
                            <TQUserIndividualResource tqResourceId = {resource.id}
                                tqResourceName = {resource.name}
                                tqResourceLink = {resource.resource_link}
                                tqResourceAuthor = {resource.author}
                                tqResourceDescription = {resource.description} />
                        )
                    })}
                </div>
            )
        }
        else{
            <div>
                <Typography use="subtitle2"> You have not Bookmarked any TQ Resource.</Typography>
            </div>
        }
        if(this.state.data.mcIntResourceDetails.length>0){
            mcIntResourceComponent = (
                <div>
                    {this.state.data.mcIntResourceDetails.map(function(resource){
                        return(
                            <UserInternalResourceComponent resourceId = {resource.id}
                                resourceName = {resource.name}
                                resourceLink = {resource.resource_link}
                                resourceAuthor = {resource.author}
                                resourceDesc = {resource.description}
                                resourceTestTrack = {resource.test_track_name}
                                bookmarkFunction = {true}
                                archiveFunction = {true} />
                        )
                    })}
                </div>
            )
        }
        else{
            <div>
                <Typography use="subtitle2"> You have not Bookmarked any MC Resource.</Typography>
            </div>
        }
        if(this.state.data.mcExtResourceDetails.length>0){
            mcExtResourceComponent = (
                <div>
                    {this.state.data.mcExtResourceDetails.map(function(resource){
                        return(
                            <UserExternalResourceComponent resourceId = {resource.id}
                                resourceName = {resource.name}
                                resourceLink = {resource.resource_link}
                                resourceAuthor = {resource.author}
                                resourceDesc = {resource.description}
                                resourceTestTrack = {resource.test_track_name}
                                bookmarkFunction = {true}
                                archiveFunction = {true} />
                        )
                    })}
                </div>
            )
        }
        else{
            <div>
                <Typography use="subtitle2"> You have not Bookmarked any MC Resource.</Typography>
            </div>
        }

        if (this.state.userAccess === true){
            displayComponent = (
                <Grid>
                    <GridCell span = "2">
                        <Button raised style={{ width: '50%' }} onClick= {((e) => handleBackAction(e))}>Back</Button>
                    </GridCell>
                    <GridCell span="12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5"> My Bookmarks Section</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span="12">
                        <Typography use="subtitle1"> The resources you have bookmarked are: </Typography>
                    </GridCell>
                    <GridCell span="11">
                        <Card style={{padding: '25px'}}>
                            {tpoResourceComponent}
                            {tqResourceComponent}
                            {mcExtResourceComponent}
                            {mcIntResourceComponent}
                        </Card>
                    </GridCell>
                </Grid>
            )
        }
        else {
            displayComponent = (
                <Grid>
                    <GridCell span = "2">
                        <Button raised style={{ width: '50%' }} onClick= {((e) => handleBackAction(e))}>Back</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">My Bookmarks Section</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="subtitle2">You will be able to access this section in the coming days.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }

    	return (
            <div>
        		{displayComponent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyBookmarksPage);


// WEBPACK FOOTER //
// ./src/views/roadmap/MyBookmarksPage.jsx